import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import GastoExtraGrid from './GastoExtraGrid.jsx'
import GastoExtraAbm from './GastoExtraAbm.jsx'
import {FormattedMessage, injectIntl} from 'react-intl';

class GastoExtra extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="gastos.label.administracion_gastos" defaultMessage="Administración de Gastos Extras"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={GastoExtraGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <GastoExtraAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <GastoExtraAbm {...props} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <GastoExtraAbm {...props} action="VIEW" />} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default GastoExtra;
